import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    fetchProducts: ['query', 'query'],
    fetchProductsSuccess: ['items', 'pagination'],
    fetchProductsFailure: ['error'],

    createProduct: ['product', 'query'],
    createProductSuccess: ['product'],
    createProductFailure: ['error'],

    fetchProduct: ['uuid', 'query'],
    fetchProductSuccess: ['product'],
    fetchProductFailure: ['error'],

    updateProduct: ['uuid', 'product', 'query'],
    updateProductSuccess: ['product'],
    updateProductFailure: ['error'],

    deleteProduct: ['uuid', 'query'],
    deleteProductSuccess: ['items'],
    deleteProductFailure: ['error'],
});


export const ProductTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    loading: false,
    error: null,
    items: [],
    product: null,
    pagination: null,
    deletedItem: null,
    lastSyncDt: null,
})

const resetState = () => INITIAL_STATE;

export const reducer = createReducer(INITIAL_STATE, {

    // Fetch work order actions
    [Types.FETCH_PRODUCTS]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            items: [],
        };
    },

    [Types.FETCH_PRODUCTS_SUCCESS]: (state, {items, pagination}) => {
        return {
            ...state,
            items,
            pagination,
            loading: false,
            error: null,
            lastSyncDt: new Date().getTime(),
        };
    },

    [Types.FETCH_PRODUCTS_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            items: [],
        };
    },

    // Create an work order
    [Types.CREATE_PRODUCT]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
            product: null,
        };
    },

    [Types.CREATE_PRODUCT_SUCCESS]: (state, { product }) => {
        return {
            ...state,
            loading: false,
            product,
            error: null,
        };
    },

    [Types.CREATE_PRODUCT_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            product: null,
        };
    },

    // Fetch a single work order
    [Types.FETCH_PRODUCT]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            product: null,
        };
    },

    [Types.FETCH_PRODUCT_SUCCESS]: (state, {product}) => {
        return {
            ...state,
            loading: false,
            error: null,
            product,
        };
    },

    [Types.FETCH_PRODUCT_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            product: null,
        };
    },

    // Update an work order
    [Types.UPDATE_PRODUCT]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    [Types.UPDATE_PRODUCT_SUCCESS]: (state, {product}) => {
        return {
            ...state,
            loading: false,
            product,
            error: null,
            lastSyncDt: new Date().getTime(),
        };
    },

    [Types.UPDATE_PRODUCT_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
        };
    },

    // Delete an existing work order
    [Types.DELETE_PRODUCT]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            deletedItem: null,
        };
    },

    [Types.DELETE_PRODUCT_SUCCESS]: (state, action) => {
        return {
            ...state,
            loading: false,
            error: null,
            deletedItem: true,
        };
    },

    [Types.DELETE_PRODUCT_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            deletedItem: null,
        };
    },
});



// WEBPACK FOOTER //
// ./src/Redux/ProductRedux.js